import React, { useEffect, useState } from "react";
import { api } from "../lib/nurseryApi";

export default function Leads() {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    api.get("/leads").then((r) => setLeads(r.data));
  }, []);

  return (
    <div data-testid="leads-page" className="fade-up">
      <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--secondary)" }}>Customer Inquiries</div>
      <h1 className="page-title" style={{ marginTop: 8 }}>Leads</h1>
      <p style={{ color: "var(--muted-fg)", marginTop: 8, marginBottom: 24, fontSize: 15 }}><b style={{ color: "var(--text)" }}>{leads.length}</b> captured · automatically synced from your chatbot.</p>

      <div className="card" style={{ padding: 0, overflowX: "auto" }}>
        <table className="soft-table">
          <thead>
            <tr><th>Name</th><th>Contact</th><th>Interest</th><th>Source</th><th>Status</th><th>When</th></tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} data-testid={`lead-row-${l.id}`}>
                <td><b>{l.name}</b></td>
                <td>{l.contact}</td>
                <td style={{ maxWidth: 320, color: "var(--text-soft)" }}>{l.interest}</td>
                <td><span className="badge badge-soft">{l.source}</span></td>
                <td><span className={`badge ${l.status === "new" ? "badge-warn" : "badge-success"}`}>{l.status}</span></td>
                <td style={{ fontSize: 12, color: "var(--muted-fg)" }}>{new Date(l.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {leads.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: "center", padding: 40, color: "var(--muted-fg)" }}>No leads yet. Customers chatting with your bot will land here.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
